import Notification from 'scripts/defa/notifications/model-notification';

/**
 * defa.collections.Notification
 * A description.
 * @version 0.1
 */

const Notifications = Bb.Collection.extend( {
	model: Notification,
	
} );

export default Notifications;